import { render } from "./StatsWidgetMenuRender.vue?vue&type=template&id=3bd72fd5&scoped=true"
import script from "./StatsWidgetMenuRender.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetMenuRender.vue?vue&type=script&lang=ts"

import "./StatsWidgetMenuRender.vue?vue&type=style&index=0&id=3bd72fd5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3bd72fd5"

export default script